/**
 * RenewablePotentialTab Component
 *
 * Main container component for renewable energy potential analysis.
 * Now refactored to use dedicated map components and custom hooks.
 */

import React, { useMemo } from 'react';
import useRenewableData from '../../../hooks/useRenewableData';
import RenewablePotentialDocumentationAccordion from './subComponents/renewablePotential/RenewablePotentialDocumentationAccordion';
import SolarEnergyPotentialCard from './subComponents/renewablePotential/SolarEnergyPotentialCard';
import WindEnergyPotentialCard from './subComponents/renewablePotential/WindEnergyPotentialCard';

const RenewablePotentialTab = ({ countryIso, isTabActive = true }) => {
  const {
    solarData,
    onshoreWindData,
    offshoreWindData,
    error,
    windErrors,
    solarThresholds,
    onshoreWindThresholds,
    offshoreWindThresholds,
    isSolarLoading,
    isWindLoading,
  } = useRenewableData(countryIso);

  const solarStatistics = solarData?.statistics;

  const SolarCard = useMemo(
    () => (
      <SolarEnergyPotentialCard
        countryIso={countryIso}
        solarData={solarData}
        solarThresholds={solarThresholds}
        solarStatistics={solarStatistics}
        isSolarLoading={isSolarLoading}
        error={error}
        isTabActive={isTabActive}
      />
    ),
    [countryIso, solarData, solarThresholds, solarStatistics, isSolarLoading, error, isTabActive]
  );

  const WindCard = useMemo(
    () => (
      <WindEnergyPotentialCard
        countryIso={countryIso}
        onshoreWindData={onshoreWindData}
        offshoreWindData={offshoreWindData}
        onshoreWindThresholds={onshoreWindThresholds}
        offshoreWindThresholds={offshoreWindThresholds}
        isWindLoading={isWindLoading}
        windErrors={windErrors}
        isTabActive={isTabActive}
      />
    ),
    [
      countryIso,
      onshoreWindData,
      offshoreWindData,
      onshoreWindThresholds,
      offshoreWindThresholds,
      isWindLoading,
      windErrors,
      isTabActive,
    ]
  );

  const RenewablePotentialDocumentationAccordionComponent = useMemo(() => {
    return <RenewablePotentialDocumentationAccordion />;
  }, []);

  return (
    <div className="w-full min-w-0 overflow-hidden px-2 md:px-4 lg:px-6 py-2 md:py-4 lg:py-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4 md:gap-6 mb-3 sm:mb-4 md:mb-6">
        {SolarCard}

        {WindCard}
      </div>

      {RenewablePotentialDocumentationAccordionComponent}
    </div>
  );
};

export default RenewablePotentialTab;
